import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// Article pages sit three levels down with nothing on them saying so. The
// visible trail and the BreadcrumbList schema are built from the same array
// so they cannot describe different paths -- and unlike FAQPage, breadcrumbs
// are still surfaced in search results.
const BlogBreadcrumbs = ({ title }) => {
  const trail = [
    { name: "Home", to: "/" },
    { name: "Blogs", to: "/blogs" },
    { name: title, to: null },
  ];

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1.5 text-[13px] text-[#6b7280]">
        {trail.map((crumb, i) => (
          <li key={crumb.name} className="flex items-center gap-1.5">
            {i > 0 && (
              <ChevronRight size={14} className="text-[#c7d0c7]" aria-hidden="true" />
            )}
            {crumb.to ? (
              <Link
                to={crumb.to}
                className="hover:text-[#117816] hover:underline underline-offset-2 transition-colors"
              >
                {crumb.name}
              </Link>
            ) : (
              // The current page is not a link. Truncated because post titles
              // run long and would otherwise wrap the trail onto three lines.
              <span
                aria-current="page"
                className="block max-w-[240px] sm:max-w-[420px] truncate text-[#111827]"
                title={crumb.name}
              >
                {crumb.name}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export const breadcrumbSchema = (title, canonicalUrl) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { name: "Home", item: "https://www.savorka.in/" },
    { name: "Blogs", item: "https://www.savorka.in/blogs/" },
    { name: title, item: canonicalUrl },
  ].map((entry, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: entry.name,
    item: entry.item,
  })),
});

export default BlogBreadcrumbs;
